import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "isLabelVisible", "isLoading", "loadingLabel", "variant", "disabled", "checked", "defaultChecked", "onChange", "name", "id", "ltr"];
import React from 'react';
import { SwitchStyles } from "./Switch.styles.js";
export var Switch = function Switch(_ref) {
  var label = _ref.label,
    _ref$isLabelVisible = _ref.isLabelVisible,
    isLabelVisible = _ref$isLabelVisible === void 0 ? true : _ref$isLabelVisible,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    loadingLabel = _ref.loadingLabel,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    onChange = _ref.onChange,
    name = _ref.name,
    id = _ref.id,
    ltr = _ref.ltr,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e.target.checked);
    }
  };
  return /*#__PURE__*/React.createElement(SwitchStyles.Wrapper, _extends({
    "data-testid": "switch-wrapper"
  }, otherProps, {
    $disabled: disabled,
    $variant: variant,
    $isLoading: isLoading,
    $ltr: ltr
  }), /*#__PURE__*/React.createElement(SwitchStyles.SwitchWrapper, {
    $disabled: disabled,
    $variant: variant,
    $ltr: ltr
  }, /*#__PURE__*/React.createElement(SwitchStyles.Input, {
    type: "checkbox",
    role: "switch",
    defaultChecked: defaultChecked,
    checked: checked,
    onChange: handleChange,
    name: name,
    id: id,
    disabled: disabled || isLoading,
    "aria-label": isLabelVisible ? undefined : label
  }), /*#__PURE__*/React.createElement(SwitchStyles.Switch, {
    $disabled: disabled,
    $variant: variant
  }), /*#__PURE__*/React.createElement(SwitchStyles.Slider, {
    $disabled: disabled,
    $variant: variant
  }, isLoading ? /*#__PURE__*/React.createElement(SwitchStyles.SliderSpinner, null) : null)), isLabelVisible ? /*#__PURE__*/React.createElement(SwitchStyles.LabelText, {
    $disabled: disabled,
    "data-testid": "switch-label-text",
    $ltr: ltr
  }, label) : null, loadingLabel && /*#__PURE__*/React.createElement(SwitchStyles.VisuallyHidden, {
    "aria-live": "polite",
    "aria-atomic": "true"
  }, isLoading ? loadingLabel : ''));
};